import mobileMenu from './js/header.js';
import uniquenessSwiper from './js/uniqueness-swiper.js';
import reviewsSwiper from './js/reviews-swiper.js';
import gallerySwiper from './js/gallery-swiper.js';
import { cookiePolicy } from './js/cookiesPolicy.js';

mobileMenu();
uniquenessSwiper();
reviewsSwiper();
gallerySwiper();
cookiePolicy();
